'use strict'

import Vue from 'vue'

export function getPreparedConfiguration (configuration, additionalFieldsConfigurations) {
  if (!configuration) {
    configuration = {}
  }
  if (!configuration.configurableFields) {
    configuration.configurableFields = []
  }
  configuration.configurableFieldsMap = {}
  configuration.additionalFields = []
  configuration.excludedFields = []
  for (const fieldConfig of configuration.configurableFields) {
    if (additionalFieldsConfigurations) {
      const fieldConfigProps = additionalFieldsConfigurations[fieldConfig.key]
      if (fieldConfigProps) {
        Object.assign(fieldConfig, fieldConfigProps)
      }
    }

    configuration.configurableFieldsMap[fieldConfig.key] = fieldConfig

    if (fieldConfig.additional) {
      if (!fieldConfig.hidden) {
        configuration.additionalFields.push(fieldConfig.key)
      }
    } else if (fieldConfig.hidden) {
      configuration.excludedFields.push(fieldConfig.key)
    }
  }

  configuration.hasAdditionalField = function (fieldKey) {
    if (this.additionalFields.includes(fieldKey)) {
      return this.isFieldIncluded(fieldKey)
    }
    return false
  }
  configuration.isFieldIncluded = function (fieldKey) {
    if (this.excludedFields.includes(fieldKey)) {
      return false
    }
    return true
  }
  configuration.isFieldReadonly = function (fieldKey) {
    const fieldConfig = this.configurableFieldsMap[fieldKey]
    return !!(fieldConfig && fieldConfig.readonly)
  }
  configuration.isFieldRequired = function (fieldKey) {
    const fieldConfig = this.configurableFieldsMap[fieldKey]
    return !!(fieldConfig && fieldConfig.required)
  }

  return configuration
}

export function addConfigurableObjectProperties (object) {
  object.setConfiguration = function (configuration) {
    // configuration = getPreparedRequestConfiguration(configuration)
    this._configuration = configuration

    for (const fieldConfig of configuration.configurableFields) {
      if (fieldConfig.additional && !Object.hasOwn(this, fieldConfig.key)) {
        Vue.set(this, fieldConfig.key, null) // TODO default value
      }
    }
  }
  object.hasAdditionalField = function (fieldKey) {
    return this._configuration.hasAdditionalField(fieldKey)
  }
  object.isFieldIncluded = function (fieldKey) {
    return this._configuration.isFieldIncluded(fieldKey)
  }
}
